import _ from "lodash";

export const formatMultiSelectedList = (list) => {
  if (_.isArray(list)) {
    return _.map(_.filter(list, (l) =>  Boolean(l?.value)), (c) => c?.value);
  }

  return [];
}